import { createFileRoute } from "@tanstack/react-router";
import DayStatistics from "../../app/views/statistics/dayStatistics";

export const Route = createFileRoute("/statistics/dayStatistics")({
  component: DayStatistics,
});
